import React from 'react';
import Text from '../../styled/Text';
import { EfiBox } from './wrappers';

interface IProps {
  items: string;
}

export const EFIInformation = ({ items }: IProps) => {
  return (
    <EfiBox>
      <Text>{items}</Text>
    </EfiBox>
  );
};
